export async function addPhone(phTypeID: number, phNum: string) {
  const addPhoneReq = await fetch('/api/account/phone/newPhone', {
    credentials: 'include',
    method: 'POST',
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      phoneTypeID: phTypeID,
      phoneNumber: phNum,
    }),
  });
  const data = await addPhoneReq.json();
  let newPID = 0;
  if(data[0] && data[0]['last_insert_id()']) {
    newPID = data[0]['last_insert_id()'];
  }
  return newPID;
}
